"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("../../User/UserAvatar"));

var _publish = _interopRequireDefault(require("../../../components/tracker/publish"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var eventTracker = function eventTracker(_ref) {
  var url = _ref.url,
      title = _ref.title,
      type = _ref.type,
      idx = _ref.idx,
      categoryId = _ref.categoryId;

  _publish.default.trackEvent('userevent', {
    type: 'Topic Clicked',
    topic_title: title,
    topic_url: url,
    topic_position: idx + 1,
    // to start index from 1 instead of 0, added +1
    topic_topic_type: type.toLowerCase() === 'discussion' ? 'conversation' : type.toLowerCase(),
    category_id: categoryId,
    click_source: 'knowledgebase'
  });
};

var ForumContentCurationItem = function ForumContentCurationItem(props) {
  var url = props.url,
      title = props.title,
      icon = props.icon,
      cdn = props.cdn,
      author = props.author,
      type = props.type,
      image = props.image,
      featuredImageAltText = props.featuredImageAltText;
  var src = '';

  if (image) {
    src = image.match(/^http/) ? image : cdn + image;
  }

  return (0, _preact.h)("li", {
    className: "topic-curation__item"
  }, (0, _preact.h)("div", {
    className: "topic-curation__item-icon"
  }, (0, _preact.h)("a", {
    className: "link",
    "aria-label": "Link to ".concat(title, " ").concat(type),
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    onClick: function onClick() {
      return eventTracker(props);
    }
  }, icon)), (0, _preact.h)("div", {
    className: "topic-curation__item-body"
  }, (0, _preact.h)("a", {
    className: "link",
    "aria-label": "Link to ".concat(title),
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    onClick: function onClick() {
      return eventTracker(props);
    }
  }, (0, _preact.h)("h3", {
    className: "topic-curation__title thread-list-block__title"
  }, title)), (0, _preact.h)("div", {
    className: "topic-curation__item-type"
  }, (0, _preact.h)("span", {
    className: "topic-curation__item-type-text"
  }, (0, _preact.h)(_phrase.default, {
    p: "knowledge.base.topic.metadata.".concat(type)
  }), (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar--XS"
  }), (0, _preact.h)("a", {
    className: "topic-curation__item-type-link",
    "aria-label": "Link to ".concat(author.name, "'s profile"),
    href: (0, _absoluteUrlRuntime.resolveUrl)("/members/".concat((author === null || author === void 0 ? void 0 : author.name).toLowerCase(), "-").concat(author.id))
  }, author.name)))), image ? (0, _preact.h)("img", {
    className: "topic-curation__item-image",
    src: (0, _absoluteUrlRuntime.resolveUrl)(src),
    alt: featuredImageAltText !== null && featuredImageAltText !== void 0 ? featuredImageAltText : title,
    role: featuredImageAltText ? 'img' : 'presentation'
  }) : null);
};

var _default = ForumContentCurationItem;
exports.default = _default;